module.exports = __webpack_public_path__ + "img/A_ezplan2.c3407faf.png";